/**
 * 随当前语言切换的格式化函数。组件里统一从这里取，不要直接调 lib/format.ts 里带 lang 参数的版本。
 */
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { fmtDwell, fmtHours, fmtNum, fmtPcs, hourText, toLang, type Lang } from './format';

export interface Fmt {
    lang: Lang;
    num: (v: number) => string;
    pcs: (v: number) => string;
    dwell: (h: number) => string;
    hours: (h: number) => string;
    hourText: (l: string) => string;
}

export function useFmt(): Fmt {
    const { i18n } = useTranslation();
    const lang = toLang(i18n.resolvedLanguage || i18n.language);
    return useMemo(
        () => ({
            lang,
            num: (v: number) => fmtNum(v, lang),
            pcs: (v: number) => fmtPcs(v, lang),
            dwell: fmtDwell,
            hours: (h: number) => fmtHours(h, lang),
            hourText: (l: string) => hourText(l, lang)
        }),
        [lang]
    );
}
